import {
  IsArray,
  IsOptional,
  IsInt,
  IsPositive,
  ArrayMaxSize,
  ValidateNested,
} from 'class-validator';
import { Type } from 'class-transformer';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { LiquidacionAgenciaFilterDto } from './liquidacion-agencia-filter.dto';

/**
 * MEJ-03 (D11): tope de filas del Excel Facturación. Un conjunto filtrado o de
 * IDs más grande se RECHAZA (400) — nunca se trunca en silencio, porque es un
 * reporte de dinero.
 */
export const FACTURACION_MAX_ROWS = 2000;

/**
 * Body de `POST /liquidaciones-agencia/facturacion` (D11). Dos modos
 * excluyentes: `ids` (selección explícita) o `filtros` (todas las filas que
 * matchean el listado). Ninguno de los dos es válido vacío a la vez.
 */
export class LiquidacionAgenciaFacturacionRequestDto {
  @ApiPropertyOptional({
    description: 'IDs de liquidaciones seleccionadas en el listado',
    type: [Number],
  })
  @IsOptional()
  @IsArray()
  @ArrayMaxSize(FACTURACION_MAX_ROWS)
  @IsInt({ each: true })
  @IsPositive({ each: true })
  ids?: number[];

  @ApiPropertyOptional({
    description:
      'Filtros del listado (modo "todas las filtradas"), mismo DTO que GET /liquidaciones-agencia',
  })
  @IsOptional()
  @ValidateNested()
  @Type(() => LiquidacionAgenciaFilterDto)
  filtros?: LiquidacionAgenciaFilterDto;
}

/** Una fila del Excel Facturación (ver `specs/agency-billing-export/spec.md`). */
export interface ILiquidacionAgenciaFacturacionRow {
  nroFactura: string;
  nroNotaCobro: string;
  numeroLiquidacion: string;
  mesAnio: string;
  cliente: string;
  estado: string;
  tipo: string;
  cntr: number;
  plts: number;
  agenciamiento: number;
  transporte: number;
  gateOutVenta: number;
  gateInVenta: number;
  osVentaTransporte: number;
  osVentaAgencia: number;
  osVentaExtra: number;
  gestionOpb: number;
  totalNeto: number;
  totalTraspasoBruto: number;
  total: number;
}

export interface ILiquidacionAgenciaFacturacionResponse {
  rows: ILiquidacionAgenciaFacturacionRow[];
}
